<template>
  <div>
    <div :id='this.$data.data.id+",3"'>
      <div v-for="(item, index) in this.dataLabelsParent" :key="index" style="float:left;">
        <ejs-chiplist id="chip-avatar-label" enableDelete="true" ref="sendData">
          <e-chips>
            <e-chip :text="item" cssClass="e-info"></e-chip>
          </e-chips>
        </ejs-chiplist>
      </div>

      <div v-for="(item, index) in this.dataLabelsSource" :key="index" style="float:left;">
        <ejs-chiplist id="chip-avatars-labels" enableDelete="true">
          <e-chips>
            <e-chip :text="item" cssClass="e-info"></e-chip>
          </e-chips>
        </ejs-chiplist>
      </div>
    </div>
    <div style="clear:both"></div>
    <!-- input框 -->
    <div :id='this.$data.data.id+"4"' style="display:none">
      <input v-model="news" class="e-input e-input-group" @blur="blurFunc" maxlength="20" @keyup.enter="keydownFunc" />
    </div>

    <!-- 加号 -->
    <div
      :id='this.$data.data.id+",5"'
      class="icon hero-icon hero-icon-add-small"
      @click="addLabels" style="color:rgb(23, 162, 184); border:1px dashed rgba(23, 162, 184,0.6);border-radius:6px;"
    ></div>
  </div>
</template>

<script>
import Vue from "vue";
import { ChipListPlugin } from "@syncfusion/ej2-vue-buttons";
import { EventBus } from "../../../plugins/eventBus";

Vue.use(ChipListPlugin);

export default Vue.extend({
  mounted() {
    const dataLabelsParentaram = JSON.parse(JSON.stringify(this.$data)).data;
    if (
      undefined !== dataLabelsParentaram.labels &&
      "" !== dataLabelsParentaram.labels
    ) {
      this.dataLabelsParent = dataLabelsParentaram.labels.split(";");
    }
  },
  data: function() {
    return {
      news: "",
      dataLabelsSource: [],
      dataLabelsParent: [],
      id: "",
      LabelFlag: false

    };
  },
  methods: {
     keydownFunc(clickEvent) {
      if (clickEvent.keyCode === 13) {
        this.LabelFlag = true;
        this.commonLabelBlurFunc(clickEvent);
      }
    },
    addLabels(args) {
      const newAddContent = document.getElementById(args.target.id); //加号ID
      this.id = args.target.id.split(",")[0];
      newAddContent.style.display = "none";
      document.getElementById(this.id + "4").style.display = "block";
    },

    commonLabelBlurFunc(args) {
      let pushLabelFlag = true;
      console.log("dataLabelsSource", this.dataLabelsSource);
      if ("" !== this.news) {
          //校验文本只能数字和字母
          if(!(/^[A-Za-z0-9]+$/.test(args.target.value))){ 
                  EventBus.$emit("toast", {
              type: "warning",
              content: "只能数字和字母"
            });
            return false;
            }
        console.log("dataLabelsParent", this.dataLabelsParent);
        if (pushLabelFlag) {
          this.dataLabelsSource.push(this.news);
        }
      }
      const newAddContent1 = document.getElementById(args.path[1].id);
      newAddContent1.style.display = "none"; //input隐藏
      document.getElementById(this.id + ",5").style.display = "block"; //加号显示
      this.$forceUpdate();
    },
    blurFunc(args) {
      if (!this.LabelFlag) {//回车触发失去焦点事件，只要一个即可
        this.commonLabelBlurFunc(args);
      }
      this.LabelFlag = false;
    }
  },
  created() {}
});
</script>

<style>
.sample-padding {
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@font-face {
  font-family: "e-chips-icons";
  font-weight: normal;
  font-style: normal;
}
</style>